import { FileInput } from "../../../utils/form";

const LicenseFile = ({ form: { control } }) =>
  <FileInput control={control} name="license" label="Foto de la credencial de tu matrícula" helperText="Necesario para la correcta validación de tu cuenta" variant="outlined" required />

export default LicenseFile;